import React from 'react'
import {HeroText, SubHeroText} from './Styles'
import BgAnimation from './BackgroundAnimation'

function HeroSection() {
    return (
        <div class="content-wrapper hero-row  d-flex flex-row align-items-center">
            <div class="row  w-100">
                <div class="col  col-md-2 col-sm-12 col-xs-12 px-5 d-flex flex-row flex-md-column align-items-center justify-content-center py-3">
                    <a href="https://github.com/SakshamBejwani" target="_blank" class="m-3 rounded-circle bg-white"><img src="github.png" class="w-10" alt="github"/></a>
                </div>
                <div class="col d-flex bg-light rounded py-5 opacity-90 flex-start justify-content-center flex-column px-5 pb-5">
                    <HeroText class="text-black">
                        SAKSHAM BEJWANI
                    </HeroText>
                    <SubHeroText class="text-black">
                    23, Self-learning software and electronics <br/>
                    engineering through research & development. 
                    </SubHeroText>
                </div>
                <div class="col py-5 w-70">
                    
                </div>
                <div class="row">
                    <div class="col px-5 d-flex flex-row-reverse  align-items-center ">
                        <a href="#workSection"><span class="badge opacity-90 rounded-pill bg-dark my-4 px-4 py-3 fw-bold hover:opacity-100">Read More</span></a>
                    </div>
                    
                </div>
            </div>
        </div>
    )
}

export default HeroSection
